import React from 'react'
import i18n from 'live/services/i18n'
import { requestCommon } from 'live/lib/utils'
import { PackageManagerHttpServicesClient, HttpClient, RestResponse } from './api'
import Subscription from 'live/services/subscription'
import { LiveHttpServicesClient } from './live-api'

export const BASE_REST_URL = '/services/plugin-package-manager/'

// TODO: in v4, re-use from live-ui https://gitlab.intelie.com/intelie/live/-/blob/next/4.0.0/webapp/js/live-core/lib/http.ts
export class JsonHttpClient implements HttpClient {
    readonly prefix: string

    constructor(prefix = '/rest/') {
        this.prefix = prefix
    }

    async request<R>(config: { method: string; data: any; url: string; headers?: HeadersInit }): RestResponse<R> {
        const response = await fetch(`${this.prefix}${config.url}`, {
            ...requestCommon,
            headers: { ...requestCommon.headers, ...config.headers },
            method: config.method,
            body: JSON.stringify(config.data)
        })

        if (!response.ok) {
            // @ts-ignore
            response.message = i18n('Error. Please try again later.')
            throw response
        }

        const text = await response.text()
        if (text && text.length > 0) {
            return JSON.parse(text)
        } else {
            return null
        }
    }
}

export const packageManagerHttpServicesClient = new PackageManagerHttpServicesClient(new JsonHttpClient(BASE_REST_URL))
export const liveHttpServicesClient = new LiveHttpServicesClient(new JsonHttpClient())

// required entities types
export const REQUIRED_ENTITIES_TYPE = { IDENTIFIED_CHANNEL: 'IDENTIFIED_CHANNEL' }

export type RequiredEntitiesType = keyof typeof REQUIRED_ENTITIES_TYPE

export function useOnRemoteChanges(callback) {
    React.useEffect(() => {
        const subscription = Subscription({ url: BASE_REST_URL + 'packages/changes-channel' })
        subscription.request().on('event', () => {
            callback()
        })
        subscription.flush()

        return () => {
            subscription.close()
        }
    }, [])
}
